import React from "react";
import Skeleton from "../common/Skeleton";

const DEFAULT_COUNT = 6;

function CatalogCardSkeleton({
  image = true,
  showCode = true,
  lines = 4,
  catalogCard = true,
  titleLines = 2,
  columnClass = "col-12 col-md-6 col-xl-4",
  imageRatio = false,
  packageCard = false,
}) {
  const card = (
    <div className={`card h-100 border-0 shadow-sm${catalogCard ? " catalog-card" : ""}${imageRatio || packageCard ? " package-card" : ""}`}>
      {image ? (
        <Skeleton
          height={imageRatio ? "auto" : 220}
          radius={0}
          className={imageRatio ? "package-card__image-skeleton" : ""}
        />
      ) : null}
      <div className="card-body d-flex flex-column">
        <div className="d-flex justify-content-between gap-3 mb-2">
          <div className="flex-grow-1">
            {showCode ? <Skeleton width="38%" height={12} className="mb-2" /> : null}
            <div style={catalogCard ? { minHeight: "2.5em" } : undefined}>
              <Skeleton width="88%" height={18} className={titleLines > 1 ? "mb-1" : ""} />
              {titleLines > 1 ? <Skeleton width="62%" height={18} /> : null}
            </div>
          </div>
          <Skeleton width={84} height={28} radius={999} />
        </div>

        <div className="small mb-3">
          {Array.from({ length: lines }, (_, index) => (
            <Skeleton
              key={index}
              width={index % 2 === 0 ? "72%" : "54%"}
              height={14}
              className={index === lines - 1 ? "" : "mb-2"}
            />
          ))}
        </div>

        <div className="mt-auto">
          <Skeleton width={110} height={31} radius={6} />
        </div>
      </div>
    </div>
  );

  if (!columnClass) return card;
  return <div className={columnClass}>{card}</div>;
}

export function PackageCardSkeleton() {
  return <CatalogCardSkeleton image showCode lines={5} columnClass="" imageRatio catalogCard />;
}

export function HotelCardSkeleton() {
  return <CatalogCardSkeleton image showCode lines={3} columnClass="" imageRatio catalogCard />;
}

export function TransportSkeleton() {
  return <CatalogCardSkeleton image showCode lines={3} columnClass="" imageRatio catalogCard />;
}

export function FlightSkeleton() {
  return <CatalogCardSkeleton image={false} showCode lines={3} columnClass="" catalogCard packageCard titleLines={2} />;
}

const VARIANT_COMPONENTS = {
  package: PackageCardSkeleton,
  hotel: HotelCardSkeleton,
  transport: TransportSkeleton,
  flight: FlightSkeleton,
};

export function CatalogSkeletonGrid({
  variant,
  count = DEFAULT_COUNT,
  label = "Loading catalog...",
}) {
  const CardSkeleton = VARIANT_COMPONENTS[variant];

  if (!CardSkeleton) return null;

  return (
    <div role="status" aria-busy="true" aria-live="polite">
      <span className="visually-hidden">{label}</span>
      <div className={variant === "package" || variant === "hotel" || variant === "transport" || variant === "flight" ? "package-catalog-grid" : "row g-4"}>
        {Array.from({ length: count }, (_, index) => (
          <CardSkeleton key={index} />
        ))}
      </div>
    </div>
  );
}
